@if (!!finding) {
  <div class="finding-header" (click)="toggleFinding()">
    <wm-finding-severity-indicator class="severity" [severity]="finding.severity" [allowModification]="!findingCollapsed && !processingFindingAction" (severityChange)="updateSeverity($event)" [attr.data-testing-id]="'finding-' + findingId + '-severity-' + finding.severity"></wm-finding-severity-indicator>
    <div class="finding-title">
      <wm-editable-inlinetext [size]="20" [readonly]="findingCollapsed || processingFindingAction" [(ngModel)]="tmpFindingTitle" (onSave)="updateTitle()" [renderHtml]="false" data-testing-id="finding-{{findingId}}-title"></wm-editable-inlinetext>
    </div>
    <div class="finding-header-actions">
        <wm-finding-share [findingIds]="[finding.id]" [projectId]="finding.projectId" (click)="$event.stopPropagation()"></wm-finding-share>
        @if (!findingCollapsed) {
          <button type="button"
                  class="finding-actions-trigger"
                  aria-label="Finding actions"
                  aria-haspopup="menu"
                  pTooltip="Finding actions"
                  tooltipPosition="top"
                  data-testing-id="finding-{{findingId}}-actions-btn"
                  [disabled]="processingFindingAction"
                  (click)="openActionMenu($event, actionButton); $event.stopPropagation()">
            @if (processingFindingAction) {
              <p-progressSpinner strokeWidth="8" [style]="{'width': '18px', 'height': '18px'}"></p-progressSpinner>
            } @else {
              <fa-icon [icon]="faEllipsisV" [fixedWidth]="true"></fa-icon>
            }
          </button>
          <p-menu appendTo="body" #actionButton [popup]="true" [model]="currentActionDropdown">
            <ng-template pTemplate="item" let-item>
              <a class="p-menuitem-link"
                 [style.--item-text-color]="item.textColor"
                 [style.--item-bg-hover-color]="item.bgHoverColor"
              >
                @if (!!item.icon) {
                  <fa-icon [icon]="item.icon" class="p-menuitem-icon"></fa-icon>
                }
                <span class="p-menuitem-text">{{ item.label }}</span>
              </a>
            </ng-template>
          </p-menu>
        }
    </div>
    @if (collapsable) {
      <div class="actions">
        @if (!findingCollapsed) {
          <fa-icon [icon]="faChevronUp" (click)="toggleFinding(); $event.stopPropagation()" data-testing-id="finding-{{findingId}}-toggle-btn"></fa-icon>
        }
        @if (findingCollapsed) {
          <fa-icon [icon]="faChevronDown" (click)="toggleFinding(); $event.stopPropagation()" data-testing-id="finding-{{findingId}}-toggle-btn"></fa-icon>
        }
      </div>
    }
  </div>
  @if (!findingCollapsed) {
    @if (showMeta && !condensedMeta) {
      <div class="finding-meta-info" [ngClass]="{'collapsed': metaCollapsed}">
        <div class="toggle">
          @if (!metaCollapsed) {
            <fa-icon [icon]="faChevronUp" (click)="toggleMeta()"></fa-icon>
          }
          @if (metaCollapsed) {
            <fa-icon [icon]="faChevronDown" (click)="toggleMeta()"></fa-icon>
          }
        </div>
        @if (!metaCollapsed) {
          <div class="finding-meta-info-item created-item">
            <div class="finding-meta-info-item-label">Created:</div>
            <wm-avatar [userId]="finding.creator" [size]="20"></wm-avatar>
            <div class="finding-meta-info-item-value">{{ finding.creationTime | wmDateFormat: 'YYYY-MM-DD HH:mm' }}</div>
          </div>
          <div class="finding-meta-info-item">
            <div class="finding-meta-info-item-label">Severity:</div>

            <div class="finding-meta-info-item-value">
             <wm-finding-severity-indicator formFactor="pill" class="severity" [severity]="finding.severity" [allowModification]="!processingFindingAction" (severityChange)="updateSeverity($event)"></wm-finding-severity-indicator>
            </div>
          </div>
          <div class="finding-meta-info-item">
            <div class="finding-meta-info-item-label">Contained in:</div>
            @if (!!finding?.auditId) {
              <div class="finding-meta-info-item-value">
                <wm-audit-ref pTooltip="Audit" [auditId]="finding?.auditId!"></wm-audit-ref>
              </div>
            }
          </div>
          <div class="finding-meta-info-item">
            <div class="finding-meta-info-item-label">Affected target:</div>
            <div class="finding-meta-info-item-value">
              @for (target of (finding?.observationTargets || []); track target) {
                <wm-observation-target class="max-width" [target]="target"></wm-observation-target>
              }
            </div>
          </div>
          <div class="finding-meta-info-item">
            <div class="finding-meta-info-item-label">Affected specs:</div>
            <div class="finding-meta-info-item-value">
              @for (spec of (finding?.affectedSpecs || []); track spec) {
                <wm-spec-ref class="max-width" [specRef]="{ 'type': 'IdBasedSpecReference', specId: spec }"></wm-spec-ref>
              }
            </div>
            @if (addSpecsAllowed && availableSpecs && availableSpecs.length > 0) {
              <div class="add-spec" (click)="addSpecPopover.show($event)">
                <fa-icon [icon]="faPlus"></fa-icon>
              </div>
              <p-popover appendTo="body" #addSpecPopover>
                <wm-spec-chooser [projectId]="finding.projectId" (onSpecsSelected)="addSpecsToFinding($event)"></wm-spec-chooser>
              </p-popover>
            }
          </div>
          <div class="finding-meta-info-item">
            <div class="finding-meta-info-item-label">Tags:</div>
            <div class="finding-meta-info-item-value">
              <wm-tags [projectId]="finding.projectId" size="small" [resourceId]="finding.id" resourceType="test_result"></wm-tags>
            </div>
          </div>
        }
        @if (metaCollapsed) {
          <div class="finding-meta-info-item">
            @for (target of (finding?.observationTargets || []); track JSON.stringify(target)) {
              <wm-observation-target class="max-width" [target]="target"></wm-observation-target>
            }
            @for (spec of (finding?.affectedSpecs || []); track spec) {
              <wm-spec-ref class="max-width" [specRef]="{ 'type': 'IdBasedSpecReference', specId: spec }"></wm-spec-ref>
            }
          </div>
        }
      </div>
    }
    @if (showMeta && condensedMeta) {
      <div class="finding-meta-info">
        <div class="finding-meta-info-item created-item">
          <div class="finding-meta-info-item-label">Created:</div>
          <wm-avatar [userId]="finding.creator" [size]="20"></wm-avatar>
          <div class="finding-meta-info-item-value">{{ finding.creationTime | wmDateFormat: 'YYYY-MM-DD HH:mm' }}</div>
        </div>
      </div>
    }
    <div class="finding-cells"
         [class.inline-add-buttons]="showInlineAddButtons"
         wmtDragDrop
         [dragEnabled]="!processingFindingAction && !uploadingAttachments"
         (filesDropped)="onAttachmentFilesDropped($event)">
      <input hidden type="file" #attachmentFileInput multiple (change)="onAttachmentFilesSelected($event)">
      <input hidden type="file" #imageFileInput accept="image/*" (change)="onImageFileSelected($event)">
      <input hidden type="file" #videoFileInput accept="video/mp4,video/webm" (change)="onVideoFileSelected($event)">
      @for (cellId of (finding?.cellSequence || []); track cellId; let i = $index) {
        @if (showInlineAddButtons) {
          <div class="cell-gutter"
               [class.visible]="hoveredCellIndex === i || hoveredCellIndex === i - 1">
            <button type="button"
                    class="add-cell-inline-trigger"
                    [disabled]="processingFindingAction || uploadingAttachments"
                    pTooltip="Add cell"
                    (click)="onInlineAddCellClick($event, i)">
              <fa-icon [icon]="faPlus"></fa-icon>
            </button>
          </div>
        }
        <div class="cell" [ngClass]="{'edit': cellId === editedCell}"
             (mouseenter)="showInlineAddButtons ? hoveredCellIndex = i : null"
             (mouseleave)="showInlineAddButtons ? hoveredCellIndex = null : null">
          @if (finding?.cells[cellId]; as cell) {
            @if (cell.type === 'TextContentCell') {
              <div class="text-cell cell-body">
                @if (editedCell !== cellId) {
                  <div class="text-cell-content cell-content body ql-editor" [innerHTML]="cell.text"></div>
                }
                @if (editedCell === cellId) {
                  <div class="text-cell-edit">
                    <p-editor [(ngModel)]="tmpCellEditContent" [style]="{'height':'320px'}">
                      <ng-template pTemplate="header">
                        <span class="ql-formats">
                        <select class="ql-size">
                          <option value="small"></option>
                          <option selected></option>
                          <option value="large"></option>
                          <option value="huge"></option>
                        </select>
                      </span>
                        <span class="ql-formats">
                        <button class="ql-bold" aria-label="Bold"></button>
                        <button class="ql-italic" aria-label="Italic"></button>
                        <button class="ql-underline" aria-label="Underline"></button>
                      </span>
                        <span class="ql-formats">
                        <button class="ql-list" value="ordered" aria-label="Ordered List"></button>
                        <button class="ql-list" value="bullet" aria-label="Unordered List"></button>
                      </span>
                        <span class="ql-formats">
                      <button class="ql-clean" aria-label="Remove Styles"></button>
                    </span>
                      </ng-template>
                    </p-editor>
                  </div>
                }
              </div>
            }
            @if (cell.type === 'ObservationContentCell' && cell.observation.type === 'ScreenshotObservation') {
              <div class="screenshot-cell cell-body">
                <div class="screenshot-cell-content cell-content" data-testing-id="screenshot-content-{{cellId}}">
                  <div class="heading-entry">
                    @if (editedCell !== cellId) {
                      <div class="heading">
                        <span>{{ screenshotsNames[cell.observation.screenshotId] }}</span>
                      </div>
                    }
                    @if (editedCell === cellId) {
                      <div>
                        <input type="text" pInputText [(ngModel)]="screenshotsNames[cell.observation.screenshotId]">
                      </div>
                    }
                  </div>

                  <wm-image
                          [imageId]="cell.observation.screenshotId"
                          [allowToOpenScreenshotToolInPopup]="!isWorkbenchContext"
                          (click)="openScreenshot(cell.observation.screenshotId); $event.stopPropagation()">
                  </wm-image>

                </div>
              </div>
            }
            @if (cell.type === 'ObservationContentCell' && cell.observation.type === 'VideoSnippetObservation') {
              <div class="videosnippet-cell cell-body">
                <div class="cell-content">
                  <div class="heading-entry">
                    @if (editedCell !== cellId) {
                      <div class="heading">
                        <span>{{ videoNames[cell.observation.videoId] }}</span>
                      </div>
                    }
                    @if (editedCell === cellId) {
                      <div>
                        <input type="text" pInputText [(ngModel)]="videoNames[cell.observation.videoId]">
                      </div>
                    }
                  </div>

                  <div class="open-link" (click)="openVideo(cell.observation.videoId)" [attr.data-testing-id]="'cell-open-video-{{cellId}}'">
                    Open Video <fa-icon [icon]="faExternalLink"></fa-icon>
                  </div>

                </div>
              </div>
            }
            @if (cell.type === 'ObservationContentCell' && cell.observation.type === 'TestMailObservation') {
              <div class="testmail-cell cell-body">
                <div class="cell-content mail-cell-content" [attr.data-testing-id]="'cell-testmail-details-{{cellId}}'">
                  <wm-mail-overview [mailId]="cell.observation.artifactId"></wm-mail-overview>
                </div>
              </div>
            }
            @if (cell.type === 'ObservationContentCell' && cell.observation.type === 'AttachmentObservation') {
              <div class="attachment-cell cell-body">
                <div class="cell-content attachment-cell-content" [attr.data-testing-id]="'cell-attachment-details-{{cellId}}'">
                  <div class="attachment-heading">
                    <div class="heading">
                      <span>{{ getAttachmentName(cell) }}</span>
                    </div>
                    @if (getAttachmentSizeLabel(cell); as attachmentSize) {
                      <div class="attachment-size">{{ attachmentSize }}</div>
                    }
                  </div>
                  <button pButton type="button" class="p-button-text p-button-sm attachment-download-button" (click)="downloadAttachment(cell.observation.blobId, getAttachmentName(cell))">
                    <fa-icon [icon]="faDownload"></fa-icon>
                    <span>Download</span>
                  </button>
                </div>
              </div>
            }
          <div class="cell-actions" [ngClass]="{'disabled': processingFindingAction}">
            <fa-icon [icon]="faEdit" (click)="editContentCell(cellId)" pTooltip="Edit cell" [attr.data-testing-id]="'content-cell-edit-' + cellId"></fa-icon>
          </div>
          <div class="cell-edit-actions">
            <fa-icon [icon]="faTimes" (click)="stopContentCellEditing();" pTooltip="Cancel editing" attr.data-testing-id="content-cell-stop-editing-{{cellId}}"></fa-icon>
            @if (!(cell.type === 'ObservationContentCell' && cell.observation.type === 'AttachmentObservation')) {
              <fa-icon [icon]="faSave" (click)="saveCellEdit()" pTooltip="Save changes" attr.data-testing-id="content-cell-save-changes-{{cellId}}"></fa-icon>
            }
            <fa-icon [icon]="faTrash" (click)="deleteCell()" pTooltip="Delete cell" attr.data-testing-id="content-cell-delete-{{cellId}}"></fa-icon>
            <fa-icon [icon]="faArrowUp" (click)="moveCellUp()" pTooltip="Move cell up" attr.data-testing-id="content-cell-move-up-{{cellId}}"></fa-icon>
            <fa-icon [icon]="faArrowDown" (click)="moveCellDown()" pTooltip="Move cell down" attr.data-testing-id="content-cell-move-down-{{cellId}}"></fa-icon>
          </div>
          }
        </div>
      }
      @if (showInlineAddButtons) {
        <div class="cell-gutter"
             [class.visible]="(finding?.cellSequence || []).length === 0 || hoveredCellIndex === (finding?.cellSequence || []).length - 1">
          <button type="button"
                  class="add-cell-inline-trigger"
                  [disabled]="processingFindingAction || uploadingAttachments"
                  pTooltip="Add cell"
                  tooltipPosition="top"
                  (click)="onInlineAddCellClick($event, (finding?.cellSequence || []).length)">
            <fa-icon [icon]="faPlus"></fa-icon>
          </button>
        </div>
      } @else {
        <div class="attachment-drop-zone">
          <button type="button"
                  class="add-cell-trigger"
                  [disabled]="processingFindingAction || uploadingAttachments"
                  (click)="onBottomAddCellClick($event)"
                  pTooltip="Add cell"
                  tooltipPosition="top"
                  data-testing-id="add-cell-btn">
            @if (uploadingAttachments) {
              <fa-icon [icon]="faSyncAlt" animation="spin"></fa-icon>
            } @else {
              <fa-icon [icon]="faPlus"></fa-icon>
            }
          </button>
        </div>
      }
      <p-popover #addCellPopover appendTo="body" styleClass="add-cell-popover">
        <div class="add-cell-dropdown">
          <p-tieredMenu [model]="addCellMenuItems">
            <ng-template pTemplate="item" let-item>
              <div class="add-cell-menu-item" [attr.data-testing-id]="'add-' + item.state.type + '-cell-btn'">
                <fa-icon [icon]="item.state.icon" [fixedWidth]="true"></fa-icon>
                <span>{{ item.label }}</span>
              </div>
            </ng-template>
          </p-tieredMenu>
          @if (addCellMenuItems.length === 0) {
            <div class="add-cell-no-results">No options available</div>
          }
        </div>
      </p-popover>
      <div class="finding-dnd-overlay"></div>
      <div class="finding-dnd-label">Drag and Drop Files here</div>
    </div>
  }
}
